import { RoomsTable } from './components/rooms-table';

export const Rooms = () => {
  return <RoomsTable />;
};
